"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
function SvgComponent(props) {
    const { fill = 'none' } = props, restProps = __rest(props, ["fill"]);
    return (react_1.default.createElement("svg", Object.assign({ "aria-hidden": 'true', focusable: 'false', className: `fl-${fill}`, width: 24, height: 24, xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 24 24' }, restProps),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM16.781 8.48967C16.489 8.19678 16.0156 8.19678 15.7237 8.48967L10.6447 13.5836L8.27634 11.2084L8.19248 11.1358C7.89979 10.9179 7.48442 10.9422 7.21899 11.2084C6.927 11.5013 6.927 11.9762 7.21899 12.2691L10.3616 15.4215C10.3619 15.4218 10.3622 15.4221 10.3625 15.4224C10.5189 15.5783 10.7722 15.5779 10.9281 15.4215L16.781 9.55033L16.8534 9.46621C17.0706 9.1726 17.0465 8.75594 16.781 8.48967Z' })));
}
exports.default = SvgComponent;
